import React from 'react';
import { NofeshServiceConsumer } from '../context/AppProvider.context';

const withNofeshService = () => (Wrapped) => {
  return (props) => {
    return (
      <NofeshServiceConsumer>
        {
          (nofeshService) => {
            return (<Wrapped {...props}
                     nofeshService={nofeshService}/>);
          }
        }
      </NofeshServiceConsumer>
    );
  }
};

export default withNofeshService;
